import styled from "styled-components";
import { Wrapper } from "../../../common/constants/core.style";
import { colors } from "../../../common/constants/color";

export const HeroMedia = styled.div`
    img {
        display: block;
        width: 100%;
        height: auto;
    }

    .mobile-image {
        display: none;
    }

    @media only screen and (max-width: 767px) {
        .desktop-image {
            display: none;
        }

        .mobile-image {
            display: block;
        }
    }
`

export const HeroPanel = styled.section`
    background: ${colors.primaryColor};
    padding: 60px 0;

    ${Wrapper} {
        max-width: 760px;
        text-align: center;
    }
`

export const HeroTagline = styled.span`
    display: inline-flex;
    align-items: center;
    gap: 8px;
    font-weight: 600;
    font-size: 13px;
    letter-spacing: 0.04em;
    text-transform: uppercase;
    color: #fff;
    background: rgba(255, 255, 255, 0.18);
    border: 1px solid rgba(255, 255, 255, 0.35);
    padding: 7px 16px;
    border-radius: 999px;

    &::before {
        content: "";
        width: 8px;
        height: 8px;
        border-radius: 50%;
        background: #7ef0b0;
    }
`

export const HeroContent = styled.div`
    h1 {
        color: #fff;
        font-size: 42px;
        line-height: 1.15;
        margin: 18px 0 14px;
    }

    p {
        color: rgba(255, 255, 255, 0.92);
        font-size: 18px;
        line-height: 1.6;
        margin-bottom: 24px;
    }

    a {
        display: inline-flex;
        align-items: center;
        gap: 10px;
        font-weight: 600;
        border-radius: 999px;
        padding: 14px 30px;
        background: #fff;
        color: ${colors.primaryColor};
        text-decoration: none;
        box-shadow: 0 10px 24px rgba(10, 10, 31, 0.25);
        transition: transform .15s ease, box-shadow .15s ease;

        &:hover {
            transform: translateY(-2px);
            box-shadow: 0 14px 30px rgba(10, 10, 31, 0.32);
        }

        svg {
            width: 18px;
            height: 18px;
        }
    }

    @media only screen and (max-width: 767px) {
        h1 {
            font-size: 32px;
        }
    }
`

export const TrustStrip = styled.section`
    background: #fff;
    border-bottom: 1px solid #e3e9f0;
`

export const TrustGrid = styled.div`
    display: grid;
    grid-template-columns: repeat(4, 1fr);
    gap: 16px;
    padding: 26px 0;

    @media only screen and (max-width: 767px) {
        grid-template-columns: repeat(2, 1fr);
        gap: 18px 12px;
    }
`

export const TrustItem = styled.div`
    display: flex;
    align-items: center;
    gap: 12px;
    justify-content: center;
    text-align: left;
    color: #1f2d3d;
    font-weight: 600;
    font-size: 15px;

    svg {
        width: 26px;
        height: 26px;
        color: ${colors.primaryColor};
        flex-shrink: 0;
    }

    @media only screen and (max-width: 767px) {
        font-size: 13px;
    }
`

export const MainSection = styled.section`
    background: ${colors.lightBG};
    padding: 60px 0 70px;
`

export const MainGrid = styled.div`
    display: grid;
    grid-template-columns: 1fr 1.25fr;
    gap: 34px;
    align-items: start;

    @media only screen and (max-width: 991px) {
        grid-template-columns: 1fr;
        gap: 26px;
    }
`

export const Intro = styled.div`
    h2 {
        font-size: 32px;
        color: ${colors.secondaryColor};
        line-height: 1.2;
        margin-bottom: 16px;

        span {
            color: ${colors.primaryColor};
        }
    }

    p {
        color: #5c6b7a;
        line-height: 1.7;
        margin-bottom: 16px;
    }
`

export const StepList = styled.ul`
    list-style: none;
    margin: 26px 0 0;
    padding: 0;
    display: grid;
    gap: 14px;

    li {
        display: flex;
        gap: 14px;
        align-items: flex-start;
        background: #fff;
        border: 1px solid #e3e9f0;
        border-radius: 14px;
        padding: 16px 18px;
    }

    strong {
        display: block;
        color: #1f2d3d;
        font-size: 15px;
    }

    span {
        color: #5c6b7a;
        font-size: 14px;
    }
`

export const StepNumber = styled.span`
    width: 34px;
    height: 34px;
    flex-shrink: 0;
    border-radius: 10px;
    display: grid;
    place-items: center;
    font-weight: 600;
    color: #fff !important;
    background: ${colors.primaryColor};
`
